import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TelegramBotConfiguration } from '@/components/admin/telegram/TelegramBotConfiguration';
import { TelegramAdminUserManagement } from '@/components/admin/telegram/TelegramAdminUserManagement';
import { TelegramMessageLogs } from '@/components/admin/telegram/TelegramMessageLogs';
import { TelegramTestDebug } from '@/components/admin/telegram/TelegramTestDebug';
import { TelegramWebhookStatus } from '@/components/admin/telegram/TelegramWebhookStatus';
import { TelegramNotificationSettings } from '@/components/admin/telegram/TelegramNotificationSettings';
import { SystemLogsMonitor } from '@/components/admin/telegram/SystemLogsMonitor';
import { TelegramTopicManagement } from '@/components/admin/telegram/TelegramTopicManagement';
import { MessageSquare } from 'lucide-react';

export default function TelegramBotManagementPage() {
  const [activeTab, setActiveTab] = useState('config');

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <MessageSquare className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-3xl font-bold">Telegram Bot Management</h1>
          <p className="text-muted-foreground">
            Configure and manage your Telegram bot integration
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-8">
          <TabsTrigger value="config">Bot Configuration</TabsTrigger>
          <TabsTrigger value="admins">Admin Users</TabsTrigger>
          <TabsTrigger value="topics">Topics</TabsTrigger>
          <TabsTrigger value="logs">Message Logs</TabsTrigger>
          <TabsTrigger value="test">Test & Debug</TabsTrigger>
          <TabsTrigger value="webhook">Webhook Status</TabsTrigger>
          <TabsTrigger value="notifications">Notifications</TabsTrigger>
          <TabsTrigger value="queue">System Logs</TabsTrigger>
        </TabsList>

        <TabsContent value="config">
          <TelegramBotConfiguration />
        </TabsContent>

        <TabsContent value="admins">
          <TelegramAdminUserManagement />
        </TabsContent>

        <TabsContent value="topics">
          <TelegramTopicManagement />
        </TabsContent>

        <TabsContent value="logs">
          <TelegramMessageLogs />
        </TabsContent>

        <TabsContent value="test">
          <TelegramTestDebug />
        </TabsContent>

        <TabsContent value="webhook">
          <TelegramWebhookStatus />
        </TabsContent>

        <TabsContent value="notifications">
          <TelegramNotificationSettings />
        </TabsContent>

        <TabsContent value="queue">
          <SystemLogsMonitor />
        </TabsContent>
      </Tabs>
    </div>
  );
}
